import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '../../../navigation/components/Layout/Layout';
import { UserInfosRequiredCard } from '../../../user/components/UserInfosRequiredCard';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { HeaderCard } from '../../components/HeaderCard';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';
import { EventInformationCard } from './components/EventInformationCard/EventInformationCard';

export const EventRegister: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data: currentEventData, loading } = useCurrentEventQuery();
  const { data: currentUserData } = useCurrentUserQuery();

  const currentEvent = currentEventData?.currentEvent ?? null;
  const currentUser = currentUserData?.currentUser;
  const hasGivenInformation =
    currentUser?.firstname && currentUser?.lastname && currentUser?.birthdate;

  const onGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Layout title="S'inscrire à un événement" activeTab="eventRegister">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          {hasGivenInformation ? (
            currentEvent ? (
              !currentEvent.hasJoined ? (
                <EventInformationCard currentEvent={currentEvent} />
              ) : (
                <Card>
                  <CardContent>
                    <Typography variant="body2">
                      {'Vous êtes déjà inscrits'}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button variant="contained" onClick={onGoToDashboard}>
                      Retourner au Dashboard
                    </Button>
                  </CardActions>
                </Card>
              )
            ) : null
          ) : (
            <UserInfosRequiredCard />
          )}
        </>
      )}
    </Layout>
  );
};
